/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import './index.css';
import { AdditionalInfoLine, CartItemContainer, OrderCardSidebarWrapper } from './styles/OrderCardSidebarStyles';
import { FullItem } from 'pages/CreateOrderPage/pages/OrderProductSettings';
import { useNavigate, useParams } from 'react-router-dom';
import sendFetch from 'common/utils/fetch';
import StatusEnum from 'common/types/StatusEnum';
import statusList from 'common/data/statusList';
import { OrderCardContentWrapper, OrderCardTimeSeparator } from './styles/OrderCardContentStyles';
import Button from 'common/components/Button';
import { ClientCard } from 'pages/CreateOrderPage/pages/OrderCompletionPage';
import Input from 'common/components/Input';
import { StyledListCard } from 'pages/CreateOrderPage/styles/CreateOrderStyles';
import Checkbox from 'common/components/Checkbox';
import { CircularProgress, Switch, useTheme } from '@mui/material';
import ClientResponseProps from 'common/types/UserResponseProps';
import TextArea from 'common/components/TextArea';

/* {
    "id": 7337509,
    "clientForOrder": {
        "id": "00000000-0000-0000-0000-000000000000",
        "firstName": "Віктор",
        "lastName": "Тетяна",
        "patronymic": "Леся",
        "phoneNumber": "+380955285880",
        "city": "Kyiv",
        "country": "Ukraine"
    },
    "acceptedDate": "2023-11-20T18:13:56.1259274",
    "issueDate": "0001-01-01T00:00:00",
    "factDate": null,
    "isGetInfoOnEmail": false,
    "isGetInfoAboutReady": null,
    "isGetReceiptOnEmail": null,
    "isPartner": true,
    "recipient": {
        "firstName": "asdf",
        "lastName": "asdf",
        "patronymic": "asdf",
        "phoneNumber": "asdf"
    },
    "employeeFirstName": null,
    "employeeLastName": null,
    "employeePatronymicName": null,
    "comment": "asdffsf",
    "statusOrder": 2,
    "priceList": "Премиум тариф",
    "serviceItem": [],
    "status": "Ok",
    "statusCode": 200
} */

type ResponseProps = {
  id: number;
  clientForOrder: {
    id: string;
    firstName: string;
    lastName: string;
    patronymic: string;
    phoneNumber: string;
    city: string;
    country: string;
  };
  acceptedDate: string;
  issueDate: string;
  departmentName: string;
  factDate: string;
  isGetInfoOnEmail: boolean;
  isGetInfoAboutReady: boolean;
  isGetReceiptOnEmail: boolean;
  isPartner: boolean;
  recipient: {
    firstName: string;
    lastName: string;
    patronymic: string;
    phoneNumber: string;
  };
  employeeFirstName: string;
  employeeLastName: string;
  employeePatronymicName: string;
  comment: string;
  statusOrder: StatusEnum;
  priceList: string;
  serviceItem: {
    id: string;
    name: string;
    categoryName?: string;
    price: number;
    count: number;
  }[];
  status: string;
  statusCode: number;
};

type OrderCardCartItemProps = {
  item: FullItem;
};

const OrderCardCartItem = ({ item }: OrderCardCartItemProps) => {
  return (
    <CartItemContainer>
      <div className='order-card-cart-item-line'>
        <p style={{ maxWidth: '250px' }}>{item.type === 'service' ? item.categoryName : item.name}</p>
        <p>{item?.price?.toFixed(2) || '0.00'} ₴</p>
      </div>
      {item.type === 'service' && (
        <div className='order-card-cart-item-line'>
          <span style={{ fontWeight: '400', maxWidth: '250px' }} className='order-card-cart-item-line-text'>{item.name}</span>
        </div>
      )}
      <div className='order-card-cart-item-line'>
        <span style={{ maxWidth: '250px' }} className='order-card-cart-item-line-text'>Кількість</span>
        <span className='order-card-cart-item-line-text'>{item.count || 1}</span>
      </div>
    </CartItemContainer>
  );
};

const ListCard = ({ name, cardWidth, selectedItem, varName, onClick }: { name: string; cardWidth: number; varName: string, selectedItem: ResponseProps, onClick: (varName: string) => void; }) => {
  const [isSelected, setIsSelected] = useState<boolean>(selectedItem[varName] || false);
  useEffect(() => {
    setIsSelected(selectedItem[varName] || false);
  }, [selectedItem, varName]);
  return (
    <StyledListCard onClick={() => { onClick(varName); }} cardWidth={cardWidth} className={isSelected ? 'active' : ''}>
      <Checkbox onChange={() => { onClick(varName); }} checked={isSelected} />
      <p>{name}</p>
    </StyledListCard>
  );
};



export default function OrderCardPage() {
  const params = useParams();
  const orderId = params.id || '';
  const theme = useTheme();
  const [responseData, setResponseData] = useState<ResponseProps>();
  const [itemList, setItemList] = useState<FullItem[]>([]);
  const [pageType, setPageType] = useState<string>('order');
  const [acceptedDate, setAcceptedDate] = useState<Date | null>(null);
  const [issueDateValue, setIssueDateValue] = useState<string>('');
  const [issueTimeValue, setIssueTimeValue] = useState<string>('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrderData = async () => {
      const formData = new FormData();
      formData.append('orderId', orderId);
      const response: [number, ResponseProps] = await sendFetch('https://api-workspace.astin.net/api/order/get-order-info', {
        method: 'POST',
        data: formData,
      });
      if (response[0] === 200) {
        const newItemList: FullItem[] = [];
        response[1].serviceItem.forEach((item) => {
          newItemList.push({
            id: item.id,
            name: item.name,
            categoryName: item.categoryName,
            price: item.price,
            count: item.count,
            type: item.categoryName ? 'service' : 'product',
          });
        });
        setItemList(newItemList);
        setResponseData(response[1]);
        setAcceptedDate(response[1].acceptedDate ? new Date(response[1].acceptedDate) : null);
        setIssueDateValue(response[1].issueDate ? response[1].issueDate.split('T')[0] : '');
        setIssueTimeValue(response[1].issueDate ? response[1].issueDate.split('T')[1].split('.')[0] : '');
      }
    };
    fetchOrderData();
  }, [orderId]);
  const totalPrice = itemList.reduce((acc, item) => acc + item.price * item.count, 0);
  const statusName = statusList.find((item) => item.value === responseData?.statusOrder)?.label || '';
  let acceptedDateText = '';
  let acceptedDateTime = '';
  if (acceptedDate) {
    acceptedDateText = `${acceptedDate.getDate() < 10 ? `0${acceptedDate.getDate()}` : acceptedDate.getDate()}.${acceptedDate.getMonth() < 10 ? `0${acceptedDate.getMonth()}` : acceptedDate.getMonth()}.${acceptedDate.getFullYear()}`;
    acceptedDateTime = `${acceptedDate.getHours() < 10 ? `0${acceptedDate.getHours()}` : acceptedDate.getHours()}:${acceptedDate.getMinutes() < 10 ? `0${acceptedDate.getMinutes()}` : acceptedDate.getMinutes()}`;
  }

  const onIssueDateChange = (e) => {
    setIssueDateValue(e.target.value);
    // update response data
    const newResponseData = { ...responseData };
    newResponseData.issueDate = e.target.value + 'T' + issueTimeValue + '.0000000';
    setResponseData(newResponseData);
  };
  const onIssueTimeChange = (e) => {
    setIssueTimeValue(e.target.value);
    // update response data
    const newResponseData = { ...responseData };
    newResponseData.issueDate = issueDateValue + 'T' + e.target.value + '.0000000';
    setResponseData(newResponseData);
  };
  const handleCardClick = (varName: string) => {
    const newResponseData = { ...responseData };
    if (responseData[varName] === null) {
      newResponseData[varName] = true;
      setResponseData(newResponseData);
      return;
    }
    newResponseData[varName] = !newResponseData[varName];
    setResponseData(newResponseData);
  };

  return (
    <div className="order-card-section">
      <h2 className='new-h2'>Картка замовлення</h2>
      <div className='order-card-content'>
        <div className='order-card-main'>
          <OrderCardContentWrapper>
            { responseData ? (<>
            <div className='order-card-main-line'>
              <p style={{ fontSize: '24px' }}>Замовлення</p>
              <span className='order-card-order-id'>{`№${orderId}`}</span>
            </div>
            <span style={{ marginBottom: '20px' }} className='order-card-title'>Клієнт</span>
            <ClientCard setPageType={setPageType} client={responseData?.clientForOrder} />
            <div className='order-card-main-time-wrapper'>
              <div className='order-card-main-time-half'>
                <div className='order-card-main-time-line'>
                  <span className='order-card-title'>Дата оформлення</span>
                  <Input value={acceptedDateText} disabled />
                </div>
                <div className='order-card-main-time-line'>
                  <span className='order-card-title'>Час оформлення</span>
                  <Input value={acceptedDateTime} disabled />
                </div>
              </div>
              <OrderCardTimeSeparator />
              <div className='order-card-main-time-half'>
                <div className='order-card-main-time-line'>
                  <span className='order-card-title'>Дата видачі</span>
                  <Input props={{ type: 'date' }} value={issueDateValue} onChange={onIssueDateChange} />
                </div>
                <div className='order-card-main-time-line'>
                  <span className='order-card-title'>Час видачі</span>
                  <Input props={{ type: 'time' }} value={issueTimeValue} onChange={onIssueTimeChange} />
                </div>
              </div>
            </div>
            <span style={{ marginBottom: '24px' }} className='order-card-title'>Клієнт згоден:</span>
            <div className='order-completion-client-card-list'>
              <ListCard
                cardWidth={200}
                name='Отримувати повідомлення про готовність замовлення'
                selectedItem={responseData}
                varName={'isGetInfoAboutReady'}
                onClick={handleCardClick}
              />
              <ListCard
                cardWidth={200}
                name='Отримувати квітанцію в ел. виді'
                selectedItem={responseData}
                varName={'isGetReceiptOnEmail'}
                onClick={handleCardClick}
              />
              <ListCard
                cardWidth={200}
                name='Отримувати повідомлення про зміни в замовлені'
                selectedItem={responseData}
                varName={'isGetInfoOnEmail'}
                onClick={handleCardClick}
              />
            </div>
            <div className='order-completion-client-switch-line'>
              <p className='new-p'>Замовлення для партнера</p>
              <Switch
                sx={{
                  '& .MuiSwitch-thumb': {
                    backgroundColor: theme.colors.gray,
                    filter: 'drop-shadow(0px 2px 1px rgba(0, 0, 0, 0.20)) drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.12))',
                  },
                  '& .MuiSwitch-track': {
                    backgroundColor: theme.colors.gray,
                  },
                  '& .Mui-checked .MuiSwitch-thumb': {
                    backgroundColor: theme.colors.primaryColor,
                  },
                }}
                checked={responseData?.isPartner || false}
                onChange={() => { setResponseData({ ...responseData, isPartner: !responseData?.isPartner }); }}
              />
            </div>
            <span style={{ marginBottom: '24px', marginTop: '20px' }} className='order-card-title'>Отримувач</span>
            <ClientCard setPageType={setPageType} client={{ ...responseData?.recipient, country:'', city:'', id:'' }} />
            <span style={{ marginBottom: '20px' }} className='order-card-title'>Коментар</span>
            <TextArea placeholder='Опишіть важливу інформацію' height={'84px'} value={responseData.comment || ''} onChange={(e) => { setResponseData({ ...responseData, comment: e.target.value }); }} />
            </>) : (
              <div className='order-card-loading-wrapper'>
                <CircularProgress sx={{ color: theme.colors.primaryColor }} />
              </div>
            )}
          </OrderCardContentWrapper>
          <div className='order-card-button-wrapper'>
            <Button onClick={() => { navigate('/services'); }} label='Повернутись' />
            <Button label='Зберегти' disabled primary />
          </div>
        </div>
        <div className='order-card-sidebar'>
          <OrderCardSidebarWrapper className='order-card-additional-info'>
            { responseData ? (<> 
            <p style={{ fontSize: '20px' }}>Додаткова інформація</p>
            <div className='order-card-additional-info-content'>
              <AdditionalInfoLine>
                <p className='order-card-additional-info-title'>Статус</p>
                <span className='order-card-additional-info-text'>{statusName}</span>
              </AdditionalInfoLine>
              <AdditionalInfoLine>
                <p className='order-card-additional-info-title'>Пункт прийому</p>
                <span className='order-card-additional-info-text'>
                  {responseData?.departmentName ? responseData.departmentName : ''}
                </span>
              </AdditionalInfoLine>
              <AdditionalInfoLine>
                <p className='order-card-additional-info-title'>Прайс-лист</p>
                <span className='order-card-additional-info-text'>{responseData?.priceList ? responseData.priceList : ''}</span>
              </AdditionalInfoLine>
              <AdditionalInfoLine>
                <p className='order-card-additional-info-title'>Виконавець</p>
                <span className='order-card-additional-info-text'>{responseData?.employeeLastName ? `${responseData.employeeLastName} ${responseData.employeeFirstName[0]}.${responseData.employeePatronymicName ? responseData.employeePatronymicName + '.' : ''}` : 'Гончаренко А.Н'}</span>
              </AdditionalInfoLine>
            </div>
            </>) : (
              <div className='order-card-loading-wrapper'>
                <CircularProgress sx={{ color: theme.colors.primaryColor }} />
              </div>
            )}
          </OrderCardSidebarWrapper>
          <OrderCardSidebarWrapper className='order-card-cart'>
            { responseData ? (<>
            <p style={{ fontSize: '20px', padding: '0px 8px' }}>Перелік замовлення</p>
            <div className='order-card-cart-list u-fancy-scrollbar'>
              {itemList.map((item, index) => <OrderCardCartItem key={index} item={item} />)}
            </div>
            <div className='order-card-cart-total'>
              <span className='order-card-cart-total-text'>Загальна сума</span>
              <span className='order-card-cart-total-price'>{totalPrice?.toFixed(2) || '0.00'} ₴</span>
            </div>
            </>) : (
              <div className='order-card-loading-wrapper'>
                <CircularProgress sx={{ color: theme.colors.primaryColor }} />
              </div>
            )}
          </OrderCardSidebarWrapper>
        </div>
      </div>
    </div>
  );
}